/* istanbul ignore file */
/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import jsCookie from 'js-cookie';
import { HEADERS } from '../../constants';

export const getSmallBusinessPayments = (payload) =>
  from(axios.post('payments/getSmallBusinessPayments', payload)).pipe(
    map(({ data: { data } }) => data)
  );
// TODO: memoize getPermissions. Ensure permissions are updated during user emulation
export const getPermissions = (requests) => () =>
  from(
    axios.post('/infrastructure/servicepermissions/isServicePermitted', {
      serviceCodes: requests
    })
  ).pipe(map(({ data: { data } }) => data));

export function simplifiedPaymentsDelete(postData) {
  return from(axios.post('/payments/simplifiedPayment/delete', postData)).pipe(
    map(({ data: { data } }) => data)
  );
}

export function simplifiedPaymentsApprove(postData) {
  const otpToken = jsCookie.get(HEADERS.X_CM_PASSCODE);
  const nextCMPasscode = jsCookie.get(HEADERS.X_NEXTCM_PASSCODE);
  const commonHeaders = axios.defaults.headers.common;
  if (otpToken) commonHeaders[HEADERS.X_CM_PASSCODE] = otpToken;
  if (nextCMPasscode) commonHeaders[HEADERS.X_NEXTCM_PASSCODE] = nextCMPasscode;
  return from(axios.post('/payments/simplifiedPayment/approve', postData)).pipe(
    map(({ data: { data } }) => {
      delete axios.defaults.headers.common[HEADERS.X_CM_PASSCODE];
      delete axios.defaults.headers.common[HEADERS.X_NEXTCM_PASSCODE];
      return data;
    })
  );
}

export function simplifiedPaymentsAction$(postData, action) {
  return from(axios.post(`/payments/simplifiedPayment/${action}`, postData)).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  );
}

export function simplifiedPaymentsReject(postData) {
  return from(axios.post('/payments/simplifiedPayment/reject', postData)).pipe(
    map(({ data: { data } }) => data)
  );
}

export const getLoanPayment = (postData) =>
  from(axios.post('/payments/simplifiedPayment/retrieveSimplifiedLoanPymntOrDraw', postData)).pipe(
    map(({ data }) => data)
  );
